<template>
   <div class="mt-8 mb-8">
      <h1 class="uppercase text-xl font-medium text-pilke-primary text-center mb-3">Tietoja lapsesta -lomake</h1>
      <div class="flex flex-no-wrap justify-center mx-auto">
         <div v-bind:class="{'completed': step.completed}" class="step-wrapper inline-block" v-for="(step, index) in storeState.steps" v-bind:key="index">
            <div class="step text-center" v-bind:class="{'step-active': step.active, 'step-completed': step.completed }">
               <img class="inline-block mx-auto w-1/2 align-baseline pb-px" v-if="step.completed" src="../assets/checkmark.png" />
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props: ['store'],

   data () {
      return {
         storeState: this.store.state
      }
   },

   components: {
   }
}
</script>

<style scoped>
.step {
   @apply rounded-full;
   @apply h-6 w-6;
   @apply bg-white;
   @apply border-2 border-solid border-pilke-gray-light;
}

.step-completed {
   @apply bg-pilke-primary;
   @apply border-pilke-primary;
}

.step-active {
   @apply bg-pilke-primary;
   @apply border-white;
   border-width: 6px;
   box-shadow: 0 0 5px rgba(0,0,0,0.3);
}

.step-wrapper {
   @apply pr-5;
   background-image: url('../assets/indicator-line-inactive.png');
   background-repeat: no-repeat;
   background-position: center center;
}

.step-wrapper.completed {
   @apply pr-5;
   background-image: url('../assets/indicator-line-completed.png');
}

.step-wrapper:last-child {
   @apply pr-0;
}
</style>
